










import { Component, Prop, Vue } from 'vue-property-decorator';
import { Auth } from '@/kuroco_api/core/Auth';
import Navigation from '@/component/view/navigation/Navigation.vue';

@Component({
  components: { Navigation },
})
export default class App extends Vue {
  async created() {
    Auth.onErrorHandler = async (res) => {
      this.$router.push({ path: '/sub/login' });
      this.$snack.danger({ text: this.$t('please_login') });
    };
  }
}
